import React, { useContext } from "react"
import Img from "gatsby-image"

import ContentfulDataContext from "../context/contentful-data"

const Images = ({ id, className = "", align, showTitle, url }) => {
  const { allContentfulAsset } = useContext(ContentfulDataContext)

  const selectedImage = allContentfulAsset.edges.filter(({ node: image }) => {
    return id && id.indexOf(image.contentful_id) > -1
  })

  if (!selectedImage.length) {
    return ""
  }

  align = align && align !== "center" ? align : ""
  const [{ node: image }] = selectedImage

  const LinkContainer = ({ children }) => (
    <>
      {url ? (
        <a href={url}>{children}</a>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}
    </>
  )

  const ImageComponent = align ? (
    <div
      className={`image-container align align-${align} ${className}`}
      style={{ float: align }}
    >
      <LinkContainer>
        <img src={image.file.url} alt={image.title} title={image.description} />
      </LinkContainer>
      {showTitle ? <p className="caption">{image.description}</p> : ""}
    </div>
  ) : (
    <div className={`image-container ${className}`}>
      <LinkContainer>
        <Img fluid={image.fluid} alt={image.title} title={image.description} />
      </LinkContainer>
      {showTitle ? <p className="caption">{image.description}</p> : ""}
    </div>
  )

  return ImageComponent
}

export default Images
